interface ArticleTextProps {
  text: string;
}

export const ArticleText = ({ text }: ArticleTextProps) => {
  return (
    <div className="prose max-w-4xl mb-6">
      <p>{text}</p>
    </div>
  );
};
